import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=0788e703&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=0788e703&prod&lang=scss&scoped=true&"
import style1 from "./OrderItem.vue?vue&type=style&index=1&id=0788e703&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788e703",
  null
  
)

export default component.exports